/* window.pmdb سحابيّ علائقيّ - المدير: توفيق كامل للشجرة. العضو: حفظ الكتب المتغيّرة فقط.
   التغييرات البنيوية (إضافة/حذف جهة أو مشروع أو كتاب) حصريّة للمدير - القاعدة ترفضها أصلًا. */
import { getProfile, relTreeLoad, relTreeSave, updateBookOnly, saveBookFinance, saveBookDeliveries, pmAddBook, pmSubmitEdit } from "./api.js";

let _lastJson = null, _lastSaveAt = 0;
const LOG = [];
if (typeof window !== "undefined") window.__tpmsLog = LOG;
function trace(...a) { try { LOG.push(a.map(String).join(" ")); } catch {} }
let _lastAlert = 0;
function loudFail(msg) {
  trace(msg);
  if (Date.now() - _lastAlert > 15000) { _lastAlert = Date.now(); try { (window.toast ? window.toast(msg, "err") : alert(msg)); } catch {} }
}
let _loadedBooks = {}; // id -> JSON للكتاب كما حُمِّل - أساس مقارنة العضو

function indexBooks(tree) {
  const map = {};
  (tree || []).forEach((p) => (p.projects || []).forEach((j) => (j.works || []).forEach((b) => { if (b.id) map[b.id] = { book: b, projId: j.id }; })));
  return map;
}
function cacheBooks(tree) {
  _loadedBooks = {};
  const m = indexBooks(tree);
  Object.keys(m).forEach((id) => { _loadedBooks[id] = JSON.stringify(m[id].book); });
}

async function appLoad() {
  try {
    const tree = await relTreeLoad(); cacheBooks(tree);
    try {
      const paths = [];
      (tree || []).forEach((p) => (p.projects || []).forEach((j) => (j.works || []).forEach((b) => {
        ["coverAr","coverFr","contractAuthor","contractTrans1","contractPublisher","printOfferFile"].forEach((k) => { if (b[k] && b[k].path) paths.push(b[k].path); });
        (b.customFiles || []).forEach((cf) => { if (cf && cf.file && cf.file.path) paths.push(cf.file.path); });
      })));
      if (paths.length) {
        const { bookFileUrls } = await import("./desktopBackup.js");
        const map = await bookFileUrls(paths);
        if (typeof window !== "undefined") { window.__bimgCache = Object.assign(window.__bimgCache || {}, map); }
      }
    } catch {}
    return tree;
  }
  catch (e) { try { console.error("[tpms] relTreeLoad", e); } catch {} return null; }
}

function findProjectOfBook(tree, bookId) {
  for (const p of tree || []) for (const j of p.projects || [])
    if ((j.works || []).some((b) => b.id === bookId)) return j.id;
  return null;
}

async function memberSave(tree) {
  const cur = indexBooks(tree);
  let failed = 0;
  for (const id of Object.keys(cur)) {
    const b = cur[id].book, s = JSON.stringify(cur[id].book);
    if (_loadedBooks[id] === s) continue; // لم يتغيّر
    if (!_loadedBooks[id]) {
      const projId = cur[id].projId;
      trace("كتاب جديد:", b.name || id, "| مشروع:", projId || "لم يوجد!");
      if (projId) {
        const r = await pmAddBook(projId, { name: b.name || "" });
        trace("pmAddBook:", r.error ? ("فشل: " + r.error) : ("نجح id=" + r.id));
        if (r.error) { failed++; loudFail(" تعذّر حفظ الكتاب «" + (b.name || "") + "»: " + r.error); continue; }
        _loadedBooks[id] = s;
      }
      continue;
    }
    const prev = _loadedBooks[id] ? JSON.parse(_loadedBooks[id]) : {};
    const strip = (x) => { const c = { ...x }; delete c.finance; delete c.deliveries; return JSON.stringify(c); };
    const bookChanged = strip(b) !== strip(prev);
    const finChanged = JSON.stringify(b.finance || null) !== JSON.stringify(prev.finance || null);
    const delChanged = JSON.stringify(b.deliveries || {}) !== JSON.stringify(prev.deliveries || {});
    if (!bookChanged && !finChanged && !delChanged) { _loadedBooks[id] = s; continue; }
    if (!window.__tpmsRole) { try { window.__tpmsRole = ((await getProfile()) || {}).role || ""; } catch { window.__tpmsRole = ""; } }
    if (window.__tpmsRole === "admin") {
      if (bookChanged) {
        const r = await updateBookOnly(b);
        if (r.error) { failed++; try { console.error("[tpms] updateBookOnly", id, r.error); } catch {} continue; }
      }
      if (finChanged) await saveBookFinance(id, b.finance || {});
      if (delChanged) await saveBookDeliveries(id, b.deliveries || {});
      _loadedBooks[id] = s;
    } else {
      const ck = [];
      try {
        const bs = JSON.parse(strip(b)); const ps = JSON.parse(strip(prev));
        const allK = new Set([...Object.keys(bs), ...Object.keys(ps)]);
        const nrm = (x) => (x === null || x === undefined) ? "" : (typeof x === "object" ? JSON.stringify(x) : String(x));
        for (const k of allK) if (nrm(bs[k]) !== nrm(ps[k])) ck.push(k);
      } catch {}
      if (finChanged) ck.push("finance");
      if (delChanged) ck.push("deliveries");
      const r = await pmSubmitEdit(id, b, ck);
      if (r.error) { failed++; try { console.error("[tpms] pmSubmitEdit", id, r.error); } catch {} continue; }
      trace("تعديل «" + (b.name || id) + "» ذهب مسودةً للاعتماد");
      try { window.dispatchEvent(new CustomEvent("tpms:draft-sent", { detail: { name: b.name || "" } })); } catch {}
      try { window.__tpmsDraftsSent = (window.__tpmsDraftsSent || 0) + 1; } catch {}
      _loadedBooks[id] = s;
    }
  }
  return failed === 0;
}

async function saveTree(json) {
  try { window.__tpmsLastSave = Date.now(); } catch {}
  let tree;
  try { tree = typeof json === "string" ? JSON.parse(json) : json; } catch { return false; }
  if (!Array.isArray(tree)) return false;
  const s = typeof json === "string" ? json : JSON.stringify(json);
  if (s === _lastJson && Date.now() - _lastSaveAt < 1500) return true;
  _lastJson = s; _lastSaveAt = Date.now();
  if (typeof window !== "undefined") window.__tpmsSaving = Date.now();
  try {
    const prof = await getProfile().catch(() => null);
    trace("saveTree: role=", prof ? prof.role : "null");
    if (!prof) { loudFail(" انتهت جلسة الدخول - لن يُحفظ شيء. سجّل الخروج ثم الدخول من جديد."); return false; }
    if (prof.role === "admin") { await relTreeSave(tree); cacheBooks(tree); return true; }
    return await memberSave(tree);
  } catch (e) { try { console.error("[tpms] saveTree", e); } catch {} return false; }
}

if (typeof window !== "undefined") {
  window.pmdb = {
    ready: async () => true,
    available: () => true,
    appLoad,
    appSave: saveTree,
    snapshotSave: saveTree,
    snapshotLoad: async () => null,
    status: async () => ({ ok: true, cloud: true, relational: true }),
    makeBackup: async () => ({ ok: false }),
    listBackups: async () => [],
    restoreBackup: async () => ({ ok: false }),
  };
}

export { appLoad, saveTree };
